import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import 'shared/components/RadioButtonList/styles.scss';

function RadioButtonList({className, onChange, options, value}) {
    const renderOptions = options.map(({value: currentValue, label}) => (
        <label className={"Label"}>
            <div className={"RadioButton"}>
                <input
                    type="radio"
                    name="payment"
                    value={currentValue}
                    checked={currentValue === value}
                    defaultChecked={currentValue === value}
                />
                <span className="Checkmark"/>
            </div>
            {label}
        </label>
    ));

    return <form
        className={classnames("RadioButtonList", className)}
        onChange={event => onChange(event.target.value)}
    >
        {renderOptions}
    </form>;
}

RadioButtonList.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    value: PropTypes.any.isRequired,
};

export default RadioButtonList;
